var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	props: {
		event: {
			type: String,
			required: true
		},
		id: {
			required: true
		}
	},
	data: function data() {
		return {
			items: []
		};
	},
	created: function created() {
		this.getHistory();
	},

	methods: {
		getHistory: function getHistory() {
			var _this = this;

			window.axios.get("/prototype/person/residents/" + this.event + "/history/" + this.id).then(function (response) {
				_this.items = _extends({}, response.data);
			});
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/new-resident-details/move-outs/NoticeHistory.vue
// module id = dUJR
// module chunks = 0 1